module.exports = __webpack_public_path__ + "static/assets/e9a87d9a0f795a7aca0120bc1d0ad540.svg";